import { useQuery } from "react-query";
import { sureApiCall } from "src/api/axiosClient/sureApi";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { DataListVersionWithDataListSchema } from "./useGetAllDataListVersions";

export const getOneDataListVersionApiKey = "getOneDataListVersion" as const;

type Options = {
    enabled?: boolean;
};

export const useGetOneDataListVersion = (dataListVersionId?: number, options?: Options) => {
    const { enabled = true } = options || {};

    const query = useQuery({
        queryKey: [getOneDataListVersionApiKey, dataListVersionId],
        queryFn: async () => {
            if (!dataListVersionId) return;

            return await sureApiCall.get(`/api/data_list_versions/${dataListVersionId}`);
        },
        select: (response) => {
            if (!response) return;

            return zodParseWithDetailedLog(response.data, DataListVersionWithDataListSchema, {
                operation: "GET",
                endpoint: "/data_list_versions/:id",
            });
        },
        enabled: enabled && dataListVersionId !== undefined && dataListVersionId > 0,
        staleTime: 300000,
        cacheTime: 300000,
    });

    return {
        dataListVersion: query.data,
        ...query,
    };
};
